import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemMailAddRoute: InvariantJiraRoute = {
	name: 'global-settings-system-mail-add',
	path: '/secure/admin/(Add|Update)PopMailServer!default.jspa',
};
